import {Injectable} from '@angular/core';
import 'rxjs/Rx';
import swal, {SweetAlertResult} from "sweetalert2";
import {MAP} from "../../../modules/hbs-services";

@Injectable()
export class ModalService {

    constructor() {
    }

    /**
     * @param params
     * example:
     * {
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Delete'
        }
     */
    showAlert(params: MAP): Promise<SweetAlertResult> {
        return swal(params);
    }

}
